const getOffsetTop = (element) => {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
};

export default function initEventTabs() {
  const banner = document.querySelector('.banner');
  const bannerHeight = banner.offsetHeight;
  const eventsSection = document.querySelectorAll('.events');
  const header = document.getElementById('header');
  const headerHeight = header.offsetHeight;
  const pastEventBlock = document.getElementById('events-past');
  const tabs = document.querySelectorAll('.js-tabs');
  const tabsInner = document.querySelector('.js-tabs-wrapper');
  const tabsInnerTopOffset = getOffsetTop(tabsInner);

  const tabsHighlighter = () => {
    const scrollY = window.pageYOffset;

    eventsSection.forEach((item) => {
      const sectionHeight = item.offsetHeight;
      const sectionTop = item.getBoundingClientRect().top + window.pageYOffset - 120;
      const sectionId = item.getAttribute('id');
      const style = window.getComputedStyle(pastEventBlock);
      if (scrollY > bannerHeight) {
        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          document.querySelector('.events-tabs__item[data-goto*=' + sectionId + ']').classList.add('is-active');
        } else {
          document.querySelector('.events-tabs__item[data-goto*=' + sectionId + ']').classList.remove('is-active');
        }
      }

      if (
        scrollY >
        getOffsetTop(pastEventBlock) + pastEventBlock.offsetHeight - parseInt(style.paddingBottom) - headerHeight
      ) {
        tabsInner.classList.add('events-tabs-wrapper--hidden');
      } else {
        tabsInner.classList.remove('events-tabs-wrapper--hidden');
      }

      handleResize();
    });
  };

  const setActiveTab = (tabs, tab = tabs[0]) => {
    tabs.forEach((tab) => {
      if (tab.classList.contains('is-active')) {
        tab.classList.remove('is-active');
      }
    });

    tab.classList.add('is-active');

    const caret = tabs[0].querySelector('span');
    caret.style.transform = `translateX(${Math.floor(tab.offsetLeft)}px)`;
    caret.style.width = `${Math.floor(tab.offsetWidth)}px`;
  };

  const handleTabsInit = () => {
    tabs.forEach((tabs) => {
      const tabsItem = tabs.querySelectorAll('a');

      tabsItem.forEach((tab) => {
        setActiveTab(tabsItem, tab[0]);
      });
    });
  };

  // Resize
  const handleResize = () => {
    const tabsList = document.querySelectorAll('.js-tabs');

    tabsList.forEach((tabs) => {
      const tabsItem = tabs.querySelectorAll('a');

      const caret = tabsItem[0].querySelector('span');

      tabsItem.forEach((tab) => {
        if (tab.classList.contains('is-active')) {
          caret.style.transform = `translateX(${Math.floor(tab.offsetLeft)}px)`;
          caret.style.width = Math.floor(tab.offsetWidth) + 'px';
        }
      });
    });
  };

  const fixedTabsOnScroll = () => {
    if (window.pageYOffset + headerHeight > tabsInnerTopOffset) {
      tabsInner.classList.add('events-tabs-wrapper-fixed');
    } else {
      tabsInner.classList.remove('events-tabs-wrapper-fixed');
    }

    if (window.pageYOffset + headerHeight - 60 > tabsInnerTopOffset) {
      tabsInner.classList.add('events-tabs-wrapper-bg');
    } else {
      tabsInner.classList.remove('events-tabs-wrapper-bg');
    }
  };

  handleTabsInit();
  window.addEventListener('resize', handleResize);
  window.addEventListener('scroll', tabsHighlighter);
  window.addEventListener('scroll', fixedTabsOnScroll);
}
